import { getIsAddButtonVisible } from "./getIsAddButtonVisible";

export function getIsCopyButtonVisible(ctx: any) {
  return getIsAddButtonVisible(ctx);
}